import { createSlice } from "@reduxjs/toolkit";

const movieSlice=createSlice({
    name:"movie",
    initialState:{
        nowplaying:null,
        videoBackground:null,
        popular:null,
        toprated:null,
        upcoming:null
    },
    reducers:{
        addMovie:(state,action)=>{
            state.nowplaying=action.payload
        },
        videoTrailer:(state,action)=>{
            state.videoBackground=action.payload
        },
        addPopular:(state,action)=>{
            state.popular=action.payload
        },
        addToprated:(state,action)=>{
            state.toprated=action.payload
        },
        addUpcoming:(state,action)=>{
            state.upcoming=action.payload
        }

    }
})
export const {addMovie,videoTrailer,addPopular,addToprated,addUpcoming}=movieSlice.actions
export default movieSlice.reducer